import {
  AcademicCapIcon,
  ArrowPathIcon,
  ArrowsPointingOutIcon,
  MinusIcon,
  PauseCircleIcon,
  PlayCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { HeroIconType } from "@utils/utils";
import { CgBorderStyleDashed } from "react-icons/cg";
import { FaHourglassEnd } from "react-icons/fa";
import { IconType } from "react-icons/lib";

import { GoalStatusEnums } from "@api/graphql/types-and-hooks";

// Map each status to its appearance
export const getStatusAppearance = (status: string) => {
  switch (status) {
    case GoalStatusEnums.Inactive:
    case GoalStatusEnums.Baseline:
      return "neutral";

    case GoalStatusEnums.Treatment:
      return "warn";

    case GoalStatusEnums.Mastered:
    case GoalStatusEnums.Maintenance:
    case GoalStatusEnums.Generalization:
      return "success";

    case GoalStatusEnums.Hold:
    case GoalStatusEnums.Closed:
      return "error";

    default:
      return "neutral";
  }
};

type GoalStatusIconType = HeroIconType | IconType;

// Map each status to an icon name
export const getStatusIcon = (status: string): GoalStatusIconType => {
  switch (status) {
    case GoalStatusEnums.Inactive:
      return FaHourglassEnd;
    case GoalStatusEnums.Baseline:
      return CgBorderStyleDashed;
    case GoalStatusEnums.Treatment:
      return PlayCircleIcon;
    case GoalStatusEnums.Mastered:
      return AcademicCapIcon;
    case GoalStatusEnums.Maintenance:
      return ArrowPathIcon;
    case GoalStatusEnums.Generalization:
      return ArrowsPointingOutIcon;
    case GoalStatusEnums.Hold:
      return PauseCircleIcon;
    case GoalStatusEnums.Closed:
      return XCircleIcon;
    default:
      return MinusIcon; // fallback
  }
};
